import { render, staticRenderFns } from "./SupplyChianCommodity.vue?vue&type=template&id=2d482b6a&scoped=true&"
import script from "./SupplyChianCommodity.vue?vue&type=script&lang=js&"
export * from "./SupplyChianCommodity.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChianCommodity.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SupplyChianCommodity.vue?vue&type=style&index=1&id=2d482b6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d482b6a",
  null
  
)

export default component.exports